<script setup>
  import { computed } from 'vue';

  const props = defineProps({
    color: {
      type: String,
      default: 'default',
      validator(value) {
        return [
          'default',
          'danger',
          'danger-heavy',
          'external',
          'success',
          'success-heavy',
          'warning',
          'waiting',
          'bright',
          'disabled',

          'average',

          'status-01',
          'status-02',
          'status-03',
          'status-04',
          'status-05',
        ].includes(value);
      },
    },
    size: {
      type: String,
      default: 'medium',
      validator(value) {
        return ['medium'].includes(value);
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  });

  const classes = computed(() => {
    const list = [
      'credere-tag',
      `color--${props.color}`,
      `size--${props.size}`,
    ];

    if (props.disabled || props.color === 'disabled') {
      list.push('state--disabled');
    }

    return list;
  });
</script>

<template>
  <span :class="classes">
    <slot />
  </span>
</template>

<style lang="scss">
  .credere-tag {
    --border-radius: var(--token-border-radius-pill);
    --color: var(--token-color-constant-dark);
    --font-size: var(--token-font-size-m);
    --padding: 0 var(--token-spacing-micro);
    --line-height: var(--token-line-height-m);

    display: inline-block;
    transition: color .1s, background-color .1s;
    white-space: nowrap;

    @container (max-width: 768px) {
      --font-size: var(--token-font-size-s);
    }

    &.color--default {
      --background-color: var(--token-color-tag-default);
      --color: var(--token-color-constant-light);
    }

    &.color--neutral {
      --background-color: var(--token-color-tag-default);
      --color: var(--token-color-constant-light);
    }

    &.color--external {
      --background-color: var(--token-color-tag-external);
    }

    &.color--warning {
      --background-color: var(--token-color-tag-warning);
    }

    &.color--waiting {
      --background-color: var(--token-color-status-01-light);
    }

    &.color--success {
      --background-color: var(--token-color-tag-success);
    }

    &.color--success-heavy {
      --background-color: var(--token-color-alert-success);
    }

    &.color--danger {
      --background-color: var(--token-color-tag-danger);
    }

    &.color--danger-heavy {
      --background-color: var(--token-color-alert-danger);
      --color: var(--token-color-constant-light);
    }

    &.color--bright {
      --background-color: var(--token-color-tag-bright);
    }

    &.color--average {
      --background-color: var(--token-color-tag-average);
    }

    &.color--status-01 {
      --background-color: var(--token-color-status-01-light);
    }

    &.color--status-02 {
      --background-color: var(--token-color-status-02-light);
    }

    &.color--status-03 {
      --background-color: var(--token-color-status-03-light);
    }

    &.color--status-04 {
      --background-color: var(--token-color-status-04-light);
    }

    &.state--disabled {
      --background-color: var(--token-color-neutral-light);
      --color: var(--token-color-neutral-primary);
    }
  }
</style>
